import { dateFormat } from '@/utils/index.js';

const DEFAULT_DATE_FMT = 'yyyy/MM/dd hh:mm'; // 默认时间格式

const filters = {
  // 格式化日期filter 使用方法: value | dateFormat("yyyy-MM-dd hh:mm:ss")
  dateFormat(value, fmt = DEFAULT_DATE_FMT) {
    return dateFormat(value, fmt);
  },
  // 手机号脱敏处理
  mobileDesensitize(tel) {
    if (!tel) return tel;
    return tel.replace(tel.substring(3, 7), '****');
  },
};

export default filters;
